import {atom} from "recoil";

const hierarchyState = atom({
  key: 'hierarchyState',
  default: 'medical',
});

export default hierarchyState;